/* eslint-disable boundaries/no-unknown-files */
import { Provider } from '@angular/core';
import { environment } from '@env/environment';
import {
    provideTranslationOnDemand,
    withLabelEndpoint,
    withDefaultLocale,
} from '@my-ul/tod-angular-client';

export function TODFactory(): Provider[] {
    return [
        provideTranslationOnDemand(
            withLabelEndpoint(environment.languageBaseUrl),
            withDefaultLocale(environment.defaultLanguage),
        ),
    ];
}
